import i from "./_assocIndexOf.js";
var r = i;
function d(s, a) {
  var t = this.__data__, e = r(t, s);
  return e < 0 ? (++this.size, t.push([s, a])) : t[e][1] = a, this;
}
var h = d;
export {
  h as default
};
//# sourceMappingURL=_listCacheSet.js.map
